import type { CustomTooltipProps } from 'ag-grid-react';
import clsx from 'clsx';
import type { MouseEvent } from 'react';
import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const Tooltip = ({ value: tag, replace, openModal }: CustomTooltipProps & { replace: string; openModal: boolean }) => {
  const t = useTranslateFn();

  const handleClick = (e: MouseEvent) => {
    if (!openModal) return;
    e.preventDefault();
    document.querySelector<HTMLPkDialogElement>('#coefficient-about-dialog')?.open();
  };

  const Tag = openModal ? 'button' : 'div';

  return (
    <Tag
      className={clsx(
        styles.tooltip,
        'pk-bg--elevation-01 pk-rounded--l pk-shadow--02 pk-py--s pk-px--m pk-mr--s',
        openModal && 'pk-text--interaction',
      )}
      onClick={handleClick}
    >
      {t(tag, { replace })}
    </Tag>
  );
};

export default memo(Tooltip);
